import service from '@api/config'


// 招标发布
export const projectPub = (data) => {
  return service.request({
    url: `/bidding/projectPub`,
    method: 'post',
    data: data
  })
}

// 保存为草稿
export const draftSave = (data) => {
  return service.request({
    url: `/project/draft/save`,
    method: 'post',
    data: data
  })
}

// 根据项目id获取报名队伍列表
export const getSignCompany = (data) => {
  return service.request({
    url: `/bidding/getSignCompany`,
    method: 'post',
    data: data
  })
}
// 根据项目id获取投标队伍列表（评标队伍列表）
export const getTenderCompany = (data) => {
  return service.request({
    url: `/bidding/getTenderCompany`,
    method: 'post',
    data: data
  })
}
// 根据项目id获取中标队伍列表（公示、竞标队伍列表）
export const getWinCompany = (data) => {
  return service.request({
    url: `/bidding/getWinCompany`,
    method: 'post',
    data: data
  })
}
// 根据项目id获取接标队伍列表（已结束队伍列表）
export const getAcceptCompany = (data) => {
  return service.request({
    url: `/bidding/getAcceptCompany`,
    method: 'post',
    data: data
  })
}
// 根据项目id 获取项目详情
export const getProjectInfo = (data) => {
  return service.request({
    url: `/bidding/getProjectInfo`,
    method: 'post',
    data: data
  })
}

// 根据队伍id获取队伍报名信息
export const getSignCompanyInfo = (data) => {
  return service.request({
    url: `/bidding/getSignCompanyInfo`,
    method: 'post',
    data: data
  })
}

// 根据投标id查询投标信息（评标、公示、竞标、结束）
export const getCompanyTenderInfo = (data) => {
  return service.request({
    url: `/bidding/getCompanyTenderInfo`,
    method: 'post',
    data: data
  })
}

// 公布中标结果
export const projectPublicity = (data) => {
  return service.request({
    url: `/bidding/projectPublicity`,
    method: 'post',
    data: data
  })
}

// 筛选公司
export const selectCompany = (data) => {
  return service.request({
    url: `/bidding/selectCompany`,
    method: 'post',
    data: data
  })
}

// 发布公告
export const projectNotice = (data) => {
  return service.request({
    url: `/bidding/projectNotice`,
    method: 'post',
    data: data
  })
}

// 根据项目id查看是否已发布公告
export const getIsNotice = (data) => {
  return service.request({
    url: `/bidding/getIsNotice`,
    method: 'post',
    data: data
  })
}

//根据项目id查看公告内容
export const getNotice = (data) => {
  return service.request({
    url: `/bidding/getNotice`,
    method: 'post',
    data: data
  })
}

// 查看投标范围内队伍
export const getLimitCompanyList = (data) => {
  return service.request({
    url: `/bidding/getLimitCompanyList`,
    method: 'post',
    data: data
  })
}
// 查看修改后投标范围内队伍
export const changeGetLimitCompanyList = (data) => {
  return service.request({
    url: `/project/change/getLimitCompanyList`,
    method: 'post',
    data: data
  })
}

// 根据队伍名查询队伍列表（模糊查询）
export const getCompanyByLetter = (data) => {
  return service.request({
    url: `/bidding/getCompanyByLetter`,
    method: 'post',
    data: data
  })
}

export const getNormalInfo = (data) => {
  return service.request({
    url: `/project/draft/normalInfo`,
    method: 'post',
    data: data
  })
}

export const getSimpleInfo = (data) => {
  return service.request({
    url: `/project/draft/simpleInfo`,
    method: 'post',
    data: data
  })
}
// 获取模板
export const pubTempelte = (data) => {
  return service.request({
    url: `/data/pubTempelte`,
    method: 'post',
    data: data
  })
}
// 获取找活人数
export const findWorkNum = (data) => {
  return service.request({
    url: `/bidding/findWorkNum`,
    method: 'post',
    data: data
  })
}
